import Timeline from 'react-headless-timeline';
import { useStyletron } from "baseui";
import { TimelineEvent } from "react-headless-timeline/dist/types/types";
import { ParagraphXSmall } from "baseui/typography";
import { FormattedDate, useIntl } from "react-intl";
import { useEffect, useMemo, useRef, useState } from "react";


const BooleanTimeline = (props: { data: TTimelineEvent[], start: Date, end: Date, onColor?: string, offColor?: string, showScale?: boolean }) => {
    const [css, theme] = useStyletron();
    const intl = useIntl();
    const onColor = props.onColor ?? theme.colors.accent;
    const offColor = props.offColor ?? theme.colors.backgroundSecondary;
    const showHeader = props.showScale ?? true;
    const elementRef = useRef<any>(null);
    const [daysInHeader, setDaysInHeader] = useState(2);
    useEffect(() => setDaysInHeader(Math.round((elementRef.current?.offsetWidth ?? 0) / 150)), [elementRef]);


    return (

        <div ref={elementRef} className={css({ boxSizing: "border-box" })} >
            <Timeline.Provider startDate={props.start} endDate={props.end} direction="horizontal">
                <>
                    <Timeline.Events
                        render={({ getEventStyles }) => (
                            <div style={{ position: 'relative', width: '100%', height: 30 }}>
                                {props.data.map((evt, i) => (
                                    <>
                                        {evt.value === true ?
                                            <div title={`${intl.formatMessage({ id: 'on' }).toUpperCase()}\n${evt.startDate.toLocaleString()} - ${evt.endDate.toLocaleString()}`}
                                                className={css({ background: onColor, borderRadius: '5px', height: '30px', minWidth: '1px' })}
                                                key={i} style={getEventStyles(evt)}>
                                            </div>
                                            :
                                            <div title={`${intl.formatMessage({ id: 'off' }).toUpperCase()}\n${evt.startDate.toLocaleString()} - ${evt.endDate.toLocaleString()}`}
                                                className={css({ background: offColor, borderRadius: '5px', height: '30px', minWidth: '1px' })}
                                                key={i} style={getEventStyles(evt)}>
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        )}
                    />
                    {showHeader &&
                        <Timeline.Headers cells={daysInHeader}
                            render={({ headers, getHeaderStyles }) => (
                                <div className={css({ position: 'relative', width: 'calc(100%-100px)', height: '25px', marginRight: '60px' })}>
                                    {headers.map((header: Date) => {
                                        return (
                                            <div style={getHeaderStyles(header)}>
                                                <ParagraphXSmall margin={0} color={theme.colors.contentTertiary} key={header.getTime()} >
                                                    <FormattedDate value={header}></FormattedDate>
                                                </ParagraphXSmall>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        />
                    }
                </>
            </Timeline.Provider>
        </div>
    );

}

export default BooleanTimeline;


export interface TTimelineEvent extends TimelineEvent {
    value: boolean
}


